const setCategory = (refresh) => {

    return {
        type: 'refresh',
        refresh
    }
}
export default setCategory